@if (showPrices()) {
  <ng-container [ngSwitch]="accessoryType()">
    <ng-container *ngSwitchCase="accessoryTypeEnum.STD">
      <ng-container *ngTemplateOutlet="type"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="accessoryTypeEnum.UR">
      <ng-container *ngTemplateOutlet="type"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="accessoryTypeEnum.RFQ">
      <ng-container *ngTemplateOutlet="manageRfq"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="accessoryTypeEnum.DASH">
      <ng-container *ngTemplateOutlet="price_tpl"></ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="price_tpl"></ng-container>
    </ng-container>
  </ng-container>
} @else {
  <span>-</span>
}

<ng-template #type>
  {{ accessoryPrice() !== null && accessoryType() ? accessoryType() : ('' | lowercase) }}
</ng-template>

<ng-template #price_tpl>
  {{ accessoryPrice() !== null ? (accessoryPrice() | apmProjectCurrency: priceCurrencySymbol()) : '' }}
</ng-template>

<ng-template #priceOrType>
  <ng-container *ngIf="!accessoryPrice(); else price_tpl">
    <ng-container *ngTemplateOutlet="type"></ng-container>
  </ng-container>
</ng-template>

<ng-template #manageRfq>
  <ng-container *ngIf="canMenageRfq && editable(); else priceOrType">
    <apm-currency-input
      #priceInput
      [(ngModel)]="rfqPrice"
      [currencyMask]="currencyMaskOptions()"
      additionalClass="w-100 text-end text"
    ></apm-currency-input>
  </ng-container>
</ng-template>
